module.exports = __webpack_public_path__ + "static/media/hangman_0.ae4a7aad.svg";